export const formatCurrency = (value) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatMonthsToYearsMonths = (totalMonths) => {
  if (!totalMonths || totalMonths === 0) return "0 months";
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  let result = "";
  if (years > 0) result += `${years} year${years > 1 ? "s" : ""}`;
  if (months > 0) {
    if (result) result += " ";
    result += `${months} month${months > 1 ? "s" : ""}`;
  }
  return result;
};
